import { Grid, Typography, Select, MenuItem, Box } from "@mui/material"
import { Images } from "./Images";
import ReactQuill from "react-quill";

export const ProductDetails = () => {
    return (
        <>
            <Grid item xs={4}>
                <Typography fontSize="12px" m="1rem 0rem 0.5rem" sx={{ color: '#747C84' }}> Product Name <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                <Select fullWidth size="small">
                    <MenuItem> Litson Belly </MenuItem>
                    <MenuItem> Crispy Pata </MenuItem>
                    <MenuItem> Fried Chicken </MenuItem>
                    <MenuItem> Roasted Liempo </MenuItem>
                </Select>
                <Typography fontSize="12px" m="1rem 0rem 0.5rem" sx={{ color: '#747C84' }}>UOM <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                <Select sx={{ width: "50%" }} size="small">
                    <MenuItem> Litson Belly </MenuItem>
                    <MenuItem> Crispy Pata </MenuItem>
                    <MenuItem> Fried Chicken </MenuItem>
                    <MenuItem> Roasted Liempo </MenuItem>
                </Select>
            </Grid>
            <Images/>
            <Grid item xs={4}>
                <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}>Category <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                <Select fullWidth size="small">
                    <MenuItem> Litson Belly </MenuItem>
                    <MenuItem> Crispy Pata </MenuItem>
                    <MenuItem> Fried Chicken </MenuItem>
                    <MenuItem> Roasted Liempo </MenuItem>
                </Select>
            </Grid>
            <Grid item xs={4}>
                <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}>Sub-Category <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                <Select fullWidth size="small">
                    <MenuItem> Litson Belly </MenuItem>
                    <MenuItem> Crispy Pata </MenuItem>
                    <MenuItem> Fried Chicken </MenuItem>
                    <MenuItem> Roasted Liempo </MenuItem>
                </Select>
            </Grid>
            <Grid item xs={4}>
                <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}>Sub Sub-Category <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                <Select fullWidth size="small">
                    <MenuItem> Litson Belly </MenuItem>
                    <MenuItem> Crispy Pata </MenuItem>
                    <MenuItem> Fried Chicken </MenuItem>
                    <MenuItem> Roasted Liempo </MenuItem>
                </Select>
            </Grid>
            <Grid item xs={4}>
                <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}>Company Own Category <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                <Select fullWidth size="small">
                    <MenuItem> Litson Belly </MenuItem>
                    <MenuItem> Crispy Pata </MenuItem>
                    <MenuItem> Fried Chicken </MenuItem>
                    <MenuItem> Roasted Liempo </MenuItem>
                </Select>
            </Grid>
            <Grid item xs={12}>
                <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}>Description <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                <ReactQuill
                    placeholder="Enter description here..."
                    modules={{
                        toolbar: [
                            ["bold", "italic"],
                            [{ list: "ordered" }, { list: "bullet" }],
                        ],
                    }}
                    style={{ height: "10rem", marginBottom: "2.5rem" }}
                />
            </Grid>
        </>
    ) 
}
